import { render, staticRenderFns } from "./OrderMineList.vue?vue&type=template&id=977b79e0&scoped=true"
import script from "./OrderMineList.vue?vue&type=script&lang=js"
export * from "./OrderMineList.vue?vue&type=script&lang=js"
import style0 from "./OrderMineList.vue?vue&type=style&index=0&id=977b79e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977b79e0",
  null
  
)

export default component.exports